import { Box, Icon } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import Date from 'modules/core/components/Date'

import { leaveFinishOn } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'

interface Props {
  leave: Leave
  disabled?: boolean
}

const DateRange = ({ leave, disabled = false }: Props) => {
  const start = moment(leave.attributes.start_on)
  const end = leaveFinishOn(leave)
  const hideEndDate = start.isSame(end)

  return (
    <Box flexDirection="row" alignItems="center" paddingRight="s24" gap="s4">
      <Date date={start} />
      {!hideEndDate && (
        <>
          <Icon.Medium icon="arrow-right" />
          <Date date={end} disabled={disabled} />
        </>
      )}
    </Box>
  )
}

export default observer(DateRange)
